import { SearchQuery } from "../code/search-query/search-query";
import ManagedGridView from "../controls/ManagedGridView";
import {
  EngagementEventType,
  pointsRulesViewColumns,
  mapPointsRulesViewQuery,
} from "./PointsRulesView.default";
import { getPointsRules } from "../repository/data.repository";
import { useSelector } from "../store/store";
import { authorizeSelectors } from "../store/authorize";
import { createGridRequest } from "../hooks/useGridRequest";
import { enumRequest } from "../utils/options";

export interface PointsRulesViewProps {
  readonly trigger?: string;
  readonly onAction?: (key: string, record: any) => void;
  readonly onSearch?: (searchQuery: SearchQuery) => void;
}

function PointsRulesView(props: PointsRulesViewProps) {
  const permissions = useSelector(authorizeSelectors.permissions);

  return (
    <ManagedGridView
      trigger={props.trigger}
      columns={pointsRulesViewColumns}
      mapQuery={mapPointsRulesViewQuery}
      onSearch={props.onSearch}
      request={createGridRequest(getPointsRules, { retry: true })}
      pageSize={100}
      schema={{
        groups: [
          {
            controls: [
              {
                type: "combobox",
                name: "eventType",
                label: "Event Type",
                request: enumRequest(EngagementEventType),
              },
              { type: "textbox", name: "description", label: "Description" },
            ],
          },
        ],
      }}
      actions={(_record) => [
        {
          key: "update",
          label: "Edit",
          disabled: !permissions.can("LoyaltyAccrualRules", "edit"),
          handler: (key, record) => props.onAction?.(key, record),
        },
        {
          key: "delete",
          label: "Delete",
          disabled: !permissions.can("LoyaltyAccrualRules", "delete"),
          danger: true,
          handler: (key, record) => props.onAction?.(key, record),
        },
      ]}
    />
  );
}

export default PointsRulesView;
